import reframe from 'reframe.js';
import './components/banner';
import './components/carousel';
import './components/collapsed';
import './components/filter-bar';
import './components/header';
import './components/image-modal';
import './components/nav';
import './components/sessions-filter';
import './components/single-submit';
import './components/tabs';
import './plugins/external-links';
import './plugins/smooth-scroll';

// Make sure videos keep their aspect ratio
reframe('iframe:not(.no-reframe)');
